/* @flow */

import React, { useContext } from "react";
import { StoreInfoContext } from "entrypoint/shared";
import { Link } from "react-router-dom";
import Wrapper from "components/Wrapper";
import cn from "classnames";
import { useTranslate } from "@awardit/react-use-translate";
import { Button } from "@crossroads/ui-components";

import styles from "./styles.scss";

type Props = {
  className: string,
  setToggleCookieDialogue: (value: boolean) => void,
  toggleCookieDialogue: boolean,
};

const AppFooter = ({
  className = "",
  setToggleCookieDialogue,
  toggleCookieDialogue,
}: Props): React$Node => {
  const { categories } = useContext(StoreInfoContext);
  const t = useTranslate();

  return (
    <footer className={cn(styles.block, className)}>
      <nav aria-label={t("FOOTER.LINKS.NAVIGATION")}>
        <div className={styles.categoriesWrapper}>
          <Wrapper className={cn(styles.wrapper)}>
            <ul className={styles.categories} aria-label="Product categories">
              {categories.map(x => (
                <li key={x.name} className={styles.category}>
                  <Link
                    className={cn("h3", styles.categoryLink)}
                    to={{
                      pathname: x.url,
                      state: { hint: { type: "category", category: x } },
                    }}
                  >
                    <span>{x.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </Wrapper>
        </div>

        <div className={styles.linksWrapper}>
          <Wrapper className={styles.wrapper}>
            <ul className={styles.links} aria-label="Customer service and legal">
              <li><Link to={t("CUSTOMER_SERVICE.LINK")}>{t("CUSTOMER_SERVICE.TEXT")}</Link></li>
              <li><Link to={t("FOOTER.LINKS.TERMS.LINK")}>{t("FOOTER.LINKS.TERMS.TEXT")}</Link></li>
              <li><Link to={t("FOOTER.LINKS.PRIVACY_POLICY.LINK")}>{t("FOOTER.LINKS.PRIVACY_POLICY.TEXT")}</Link></li>
              <li>
                <Button
                  className={styles.link}
                  aria-expanded={toggleCookieDialogue ?? "true"}
                  aria-controls="cookieDialogue"
                  onClick={() => setToggleCookieDialogue(true)}
                >
                  {t("FOOTER.NEED_HELP.COOKIES")}
                </Button>
              </li>
              <li><Link to={t("FOOTER.LINKS.ACCESSIBILITY.LINK")}>{t("FOOTER.LINKS.ACCESSIBILITY.TEXT")}</Link></li>
            </ul>
          </Wrapper>
        </div>
      </nav>

      <div className={styles.copyright}>
        <Wrapper className={styles.copyrightWrapper}>
          <p>{t("FOOTER.COPYRIGHT", { year: new Date().getFullYear() })}</p>
          <p dangerouslySetInnerHTML={{ __html: t("FOOTER.LEGAL", { year: new Date().getFullYear() }) }} />
        </Wrapper>
      </div>
    </footer>
  );
};

export default AppFooter;
